import { blocks, customization } from '@yola/ws-sdk';
import get from 'lodash.get';
import {
  SURFACES,
  SURFACES_SECONDARY,
  SURFACES_PRIMARY,
} from 'src/js/modules/blocks/constants/display-options';

const isRecomendedSurfaceAllowable = (node, surfaces) => {
  const blockId = blocks.accessors.getBlockIdByElement(node);
  const currentPalette = customization.accessors.getCurrentColorPalette();
  const blockSettings = blocks.accessors.getBlockSettings(blockId, currentPalette);
  const surfaceList = surfaces.split(' ');

  const surfaceOptions = [SURFACES, SURFACES_PRIMARY];

  if (surfaceList.length > 1) {
    surfaceOptions.push(SURFACES_SECONDARY);
  }

  const displayOptions = (blockSettings.displayOptions || []).filter(
    (option) => !option.hidden && surfaceOptions.includes(option.id)
  );

  return displayOptions.every((surfaceOption) => {
    const options = get(surfaceOption, 'options', []);
    if (!Number.isInteger(surfaceOption.index)) {
      return options.some((opt) => opt.value === surfaces);
    }
    return options.some((opt) => opt.value === surfaceList[surfaceOption.index]);
  });
};

export default isRecomendedSurfaceAllowable;
